/* tslint:disable */
/* eslint-disable */
export enum WorkChatEventKindEnum {
  MessageCreated = 'messageCreated',
  MessageUpdated = 'messageUpdated',
  MessageDeleted = 'messageDeleted',
  ChatUpdated = 'chatUpdated',
  Read = 'read'
}
